import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CardComponent} from './card.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';


@NgModule({
    declarations: [
        CardComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        TranslateModule,

        MatButtonModule,
        MatIconModule
    ],
    exports: [
        CardComponent
    ]
})
export class CardModule {
}
